import { render, staticRenderFns } from "./vipTypeManage.vue?vue&type=template&id=72538c89&"
import script from "./vipTypeManage.vue?vue&type=script&lang=js&"
export * from "./vipTypeManage.vue?vue&type=script&lang=js&"
import style0 from "./vipTypeManage.vue?vue&type=style&index=0&id=72538c89&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports